import { blue, Palette } from '@ant-design/colors'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { Flex, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Text, Paragraph } = Typography

interface Props {
  item: any
  color?: Palette
}

const AvatarCard = ({ item, color }: Props) => {
  if (!color) {
    color = blue
  }
  return (
    <Link to={`/settings/${item.url}`}>
      <Space orientation="vertical" size={10} align="center">
        <Flex
          align="center"
          justify="center"
          style={{
            width: 50,
            height: 50,
            backgroundColor: color[4],
            borderRadius: 50,
            padding: 12,
          }}
        >
          <Text
            style={{
              color: 'white',
              fontSize: 24,
            }}
          >
            <SBIcon name={item.iconPage} />
          </Text>
        </Flex>
        <Space orientation="vertical" size={0}>
          <Text style={{ fontWeight: 'bold' }}>{item.title}</Text>
          <Paragraph
            type="secondary"
            ellipsis={{ rows: 2 }}
            style={{ margin: 0 }}
          >
            {item.description}
          </Paragraph>
        </Space>
      </Space>
    </Link>
  )
}

export { AvatarCard }
